/**
 *
 * @param pageId: 页面ID
 * @file: 进行页面之间信息传递
 */
import store from '../store/index';
import { FMicroEvent } from '../typings/index';

let isHandling = false;

export default function (callback: (value: FMicroEvent) => void) {
  // 进行 wrap 注册
  const wrapper = () => {
    if (isHandling) {
      return;
    }
    isHandling = true;
    const state = store.getState();
    const eventPool = state.get('eventPool');
    if (eventPool && Array.isArray(eventPool) && eventPool.length > 0) {
      eventPool.map(item => callback(item as FMicroEvent));
      store.dispatch({ type: 'COMMIT_EVENT', payload: [] });
    }
    isHandling = false;
  }
  return store.subscribe(wrapper);
}
